import React from "react";
import styled from "styled-components";
import { InlineLink } from "../components/link";
import { Content } from "../components/content";
import { ContentLinks } from "../components/content-links";
import { H1, H3, H4, Text, Label } from "../components/text";
import { Hero } from "../components/hero";
import { Layout } from "../components/layout";
import { Seo } from "../components/seo";
import { Spacer } from "../components/spacer";
import HeroImage from "../images/pages/contact/hero.jpg";
import { Grid } from "../components/grid";
import { Column } from "../components/column";
import FacebookLogo from "../images/social-networks/facebook.svg";
import InstagramLogo from "../images/social-networks/instagram.svg";
import SEOImage from "../images/wvs-india-seo.jpg";

const SocialLinks = styled.div`
  display: flex;
  justify-content: flex-start;
`;

const SocialImage = styled.img`
  width: 30px;
`;

const Index = () => {
  return (
    <Layout>
      <Seo lang='en' title='Contact' image={SEOImage} />
      <Hero image={HeroImage}>
        <H1>Contact</H1>
      </Hero>
      <Content>
        <H3>WVS India</H3>
        <Spacer height={2} />
        <InlineLink
          href='https://www.facebook.com/groups/161606807221882/'
          title='WVS ITC India'
          rel='noopener noreferrer'
          target='_blank'
        >
          <SocialImage alt='Facebook logo' src={FacebookLogo} />
        </InlineLink>
        <Spacer height={2} />
        <Grid columns={3}>
          <Column>
            <Text>
              <Label>WVS India Chairman:</Label>
              <br />
              Nigel Otter
              <br />
              <InlineLink
                href='tel:+9109443699376'
                title='+9109443699376'
                rel='noopener noreferrer'
                target='_blank'
              >
                +91 (0) 944 369 9376
              </InlineLink>
            </Text>
            <Text>
              <Label>WVS India Clinical Director:</Label>
              <br />
              Dr Sumanth
              <br />
              <InlineLink
                href='mailto:drsumanth@wvsindia.org'
                title='drsumanth@wvsindia.org'
                rel='noopener noreferrer'
                target='_blank'
              >
                drsumanth@wvsindia.org
              </InlineLink>
            </Text>
            <Text>
              <Label>WVS India Accountant:</Label>
              <br />
              Mr Wilson
              <br />
              <InlineLink
                href='mailto:wilson@wvsindia.org'
                title='wilson@wvsindia.org'
                rel='noopener noreferrer'
                target='_blank'
              >
                wilson@wvsindia.org
              </InlineLink>
            </Text>
            <Text>
              <Label>WVS India Participant Coordinator:</Label>
              <br />
              Arnab Barua
              <br />
              <InlineLink
                href='mailto:arnab.barua@wvsindia.org'
                title='arnab.barua@wvsindia.org'
                rel='noopener noreferrer'
                target='_blank'
              >
                arnab.barua@wvsindia.org
              </InlineLink>
            </Text>
          </Column>
          <Column>
            <Text>
              <Label>Location on Google Maps:</Label>
              <br />
              <InlineLink
                href='https://goo.gl/maps/tEgYG3h6qyygEkf38'
                title='WVS India'
                rel='noopener noreferrer'
                target='_blank'
              >
                WVS India
              </InlineLink>
            </Text>
            <Text>
              <Label>Email address:</Label>
              <br />
              <InlineLink
                href='mailto:info@wvsindia.org'
                title='info@wvsindia.org'
                rel='noopener noreferrer'
                target='_blank'
              >
                info@wvsindia.org
              </InlineLink>
            </Text>
            <Text>
              <Label>Phone number:</Label>
              <br />
              <InlineLink
                href='tel:+914232204538'
                title='+914232204538'
                rel='noopener noreferrer'
                target='_blank'
              >
                +91 (0) 423 220 4538
              </InlineLink>
            </Text>
            <Text>
              <Label>Address:</Label>
              <br />
              WVS India
              <br />
              Gramya Bhavan/RDO-building complex
              <br />
              Aruvankadu
              <br />
              643202 Nilgiris district
              <br />
              Tamil Nadu, India
            </Text>
          </Column>
        </Grid>
        <Spacer height={3} />
        <H4>How to get to the WVS India center in Ooty</H4>
        <Text>
          Depending on the direction you are coming from, you should arrive to
          Coimbatore or to Bangalore first.
        </Text>
        <ul>
          <li>
            From Bangalore, take an overnight bus to Ooty (8 hours) and from
            Ooty bus station, take a local bus to Coonoor and ask the driver to
            stop at Kanigarajnagar – village bus stop. ITC is 50meters ahead, on
            the right side of the road.
          </li>
          <li>
            From Coimbatore, take a bus to Ooty and get off about 20 min before
            Ooty (2km after Aruvankadu Cordite factory) in the same
            Kanigarajnagar – village.
          </li>
        </ul>
      </Content>
      <ContentLinks />
    </Layout>
  );
};

export default Index;
